import { withLocalizer } from "./withLocalizer";
import { useLocation, useNavigate } from "react-router-dom";

export const withRouter = (Component) => {
    const Wrapper = (props) => {
        const navigate = useNavigate();
        const location = useLocation();

        return (
            <Component
                navigate={navigate} // Pass the setLocation function as `navigate`
                currentRoute={location?.pathname} // Pass the current route
                {...props}
            />
        );
    };

    return withLocalizer(Wrapper);
};